export enum DeeplinkActions {
  VIEW_FEED = 'viewFeed',
  VIEW_REQUEST = 'viewRequest',
}

export interface DeeplinkParams {
  params: string;
  requestId: string;
}
